import styled from 'styled-components';
import { RED, BLUE, STATS } from '../../constants/constants';
import { BoardGridTray } from '../Board/styles';
import { ESWrapper } from '../Board/EnteringSpace';

export const GamePieceContainer = styled.div`
  z-index: 5;
  background-color: #ddd;
  padding: 2px;
  width: 90px;
  border-radius: 12px;
  border-style: outset;
  cursor: pointer;
  box-shadow: rgba(6, 24, 44, 0.4) 0 0 0 2px,
    rgba(6, 24, 44, 0.65) 0 4px 6px -1px,
    rgba(255, 255, 255, 0.08) 0 1px 0 inset;

  ${BoardGridTray} & {
    position: relative;
    cursor: default;
  }
  ${BoardGridTray} > &::after {
    content: '';
    position: absolute;
    inset: 0;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background-color: #333;
    opacity: 0.8;
  }

  // If the piece is in the entering space,
  // then the piece is positioned absolutely
  // and should be stacked on top of the entering space.

  ${ESWrapper} &:nth-child(2) {
    top: -2px;
  }
  ${ESWrapper} &:nth-child(3) {
    top: -8px;
  }
`;

export const SVG = styled.svg`
  border: 0;
  margin-bottom: -5px;
  fill: ${({ fillColor }) =>
    fillColor === RED ? STATS[RED].hexColor : STATS[BLUE].hexColor};
  width: 100%;
  height: 100%;
`;

export const SVGPolyline = styled.polyline`
  fill: transparent;
  stroke: #fff;
  stroke-width: 4;
`;

export const SVGPath = styled.path`
  fill: none;
  stroke: black;
  stroke-width: 4px;
`;

export const SVGRect = styled.rect`
  fill: url(#grid);
  height: 100%;
  width: 100%;
`;

export const GamePieceCover = styled.div`
  width: 85%;
  height: auto;
  padding: 0;
  border: 0;
  margin: 0 auto;
  background-color: ${({ bgColor }) =>
    bgColor === RED ? STATS[RED].hexColor : STATS[BLUE].hexColor};
`;

export const GamePieceContainerBG = styled.div`
  background-color: #000;
  margin: 0 auto;
  padding: 2px;
  width: 90%;
  border-radius: 12px;
`;
